module.exports = function(app) {
	bootstrap.run(['Service','sessionData', function(Service, sessionData) {
		new Service({

			name: 'dependentsPCP',
			group:'rbsmbl',
			url:'/rbsmbl/x-services/asp/pcp/dependent',
			cache: false,

			fetch: function(payload) {
                if(sessionData && sessionData.clientNumber && sessionData.clientNumber !== undefined){
                    this.headers['ClientNumber']  = sessionData.clientNumber;
                }
				return this.get(payload);
			}
		});
	}]);
};
